import { useState, useCallback } from 'react';
import { ExtendedMarkerData } from '../types/marker';

interface ValidationErrors {
  name?: string;
  contact_address?: string;
  categoryId?: string;
  email?: string;
  phone?: string;
}

export const useFormValidation = () => {
  const [errors, setErrors] = useState<ValidationErrors>({});

  const validateEmail = (email: string | undefined): boolean => {
    if (!email) return true; // Email est optionnel
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone: string | undefined): boolean => {
    if (!phone) return true; // Téléphone est optionnel
    const phoneRegex = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;
    return phoneRegex.test(phone);
  };

  const validateForm = useCallback((data: ExtendedMarkerData): boolean => {
    const newErrors: ValidationErrors = {};

    // Validation de la catégorie (seul champ requis)
    if (!data.categoryId) {
      newErrors.categoryId = 'La catégorie est requise';
    }

    // Validation du format email s'il est fourni
    if (data.email && !validateEmail(data.email)) {
      newErrors.email = 'Format d\'email invalide';
    }

    // Validation du format téléphone s'il est fourni
    if (data.phone && !validatePhone(data.phone)) {
      newErrors.phone = 'Format de téléphone invalide';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, []);

  const clearErrors = useCallback(() => {
    setErrors({});
  }, []);

  const setFieldError = useCallback((field: keyof ValidationErrors, message: string) => {
    setErrors(prev => ({ ...prev, [field]: message }));
  }, []);

  return {
    errors,
    validateForm,
    clearErrors,
    setFieldError
  };
};

